/**
 * aminos-cart-confetti.js
 *
 * AA - Custom: confetti burst when the cart crosses the free-shipping
 * threshold for the first time per page-load. Listens on the document
 * for the cart drawer re-rendering — Sleek's cart-drawer.js dispatches
 * its own cart events; we use a MutationObserver as a vendor-agnostic
 * trigger that watches for the shipping bar transitioning from
 * in-progress → complete. That way we don't depend on Sleek's
 * specific event names.
 *
 * Once fired, we tag the body so subsequent re-renders (e.g. opening
 * the drawer again) don't re-fire confetti for the same already-met
 * threshold. Resetting requires a page reload — intentional, so the
 * effect remains "delightful" not "noisy".
 */
(function () {
  'use strict';

  var COLORS = ['#f47529', '#febf26', '#85a452', '#FF7722', '#4A7C4E'];
  var BODY_FLAG = 'aa-shipping-confetti-fired';
  var observer = null;

  function fireConfetti(container) {
    if (!container) return;
    if (document.body.classList.contains(BODY_FLAG)) return;

    for (var i = 0; i < 30; i++) {
      var piece = document.createElement('div');
      piece.className = 'aminos-cart-shipping-bar__confetti-piece';
      piece.style.left = Math.random() * 100 + '%';
      piece.style.backgroundColor = COLORS[Math.floor(Math.random() * COLORS.length)];
      piece.style.animationDelay = (Math.random() * 0.5) + 's';
      var size = (Math.random() * 8 + 6);
      piece.style.width = size + 'px';
      piece.style.height = size + 'px';
      piece.style.borderRadius = Math.random() > 0.5 ? '50%' : '2px';
      container.appendChild(piece);
      requestAnimationFrame(function (el) { return function () { el.classList.add('is-animating'); }; }(piece));
      setTimeout((function (el) { return function () { el.remove(); }; })(piece), 2000);
    }

    document.body.classList.add(BODY_FLAG);
  }

  function checkForComplete() {
    var bar = document.querySelector('.aminos-cart-shipping-bar--complete');
    if (!bar) return;
    var container = bar.querySelector('[data-confetti-container]');
    fireConfetti(container);
  }

  function start() {
    // Initial check on page load (in case the cart is already qualified)
    checkForComplete();

    // Watch the document for any subtree changes — when the cart drawer
    // re-renders (Sleek replaces innerHTML on its own elements), the
    // shipping bar markup is recreated; checkForComplete picks up the
    // new state. Throttled with requestAnimationFrame to avoid hammering.
    var scheduled = false;
    observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        checkForComplete();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
